module.exports = __webpack_public_path__ + "img/Ascot_logo.e89f452e.png";